module.exports = __webpack_public_path__ + "static/img/JT_H5.19c1f06.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banner/company-logo/JT_H5.png
// module id = H9zo
// module chunks = 34